export default __webpack_public_path__ + "static/media/delete_account_header.c55068e9.png";